// extracted by mini-css-extract-plugin
export var bd = "DownloadNav-module--bd--155c9";
export var bigger = "DownloadNav-module--bigger--2e084";
export var detail = "DownloadNav-module--detail--32aaa";
export var downloadBar = "DownloadNav-module--download-bar--43ee1";
export var footBottom = "DownloadNav-module--foot-bottom--bb919";
export var footBottomDesc = "DownloadNav-module--foot-bottom-desc--c078c";
export var footerBottom = "DownloadNav-module--footer-bottom--ca86e";
export var ft = "DownloadNav-module--ft--9775b";
export var logo = "DownloadNav-module--logo--259a2";
export var red = "DownloadNav-module--red--2ae30";